import { render } from "./PackageDetail.vue?vue&type=template&id=3f438e94&scoped=true"
import script from "./PackageDetail.vue?vue&type=script&lang=js"
export * from "./PackageDetail.vue?vue&type=script&lang=js"

import "./PackageDetail.vue?vue&type=style&index=0&id=3f438e94&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3f438e94"

export default script